import {
	lazy,
} from 'react'

export const RulesDetailPageAsync = lazy(async() => {
	return import('./rules-detail.page')
})
